export default "__VITE_ASSET__5Nza6GiQ__"